<script setup lang="ts">
import { computed } from 'vue'
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { FooterBlock } from '../../types'

const props = defineProps<{ block: FooterBlock }>()
const brandLink = computed(() => props.block.content.brandLink ?? {
  label: props.block.content.businessName,
  destination: { type: 'page' as const, path: '/' },
})
</script>

<template>
  <footer :id="block.settings.anchorId" class="site:bg-(--site-color-text) site:py-12 site:text-(--site-color-primary-text) site:@min-[40rem]:py-16">
    <div class="site-site-container">
      <div class="site:grid site:gap-12 site:@min-[64rem]:grid-cols-[1fr_1.4fr]">
        <div class="site:max-w-sm">
          <SiteLink :link="brandLink" class="site-heading site:text-2xl site:font-bold">{{ block.content.brandLink?.label ?? block.content.businessName }}</SiteLink>
          <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-4 site:leading-7 site:opacity-65" />
          <div v-if="block.content.socialLinks?.length" class="site:mt-6 site:flex site:flex-wrap site:gap-4">
            <SiteLink v-for="(link, index) in block.content.socialLinks" :key="`${link.label}-${index}`" :link="link" class="site:text-sm site:font-semibold site:opacity-75">{{ link.label }}</SiteLink>
          </div>
        </div>

        <div class="site:grid site:grid-cols-2 site:gap-8 site:@min-[40rem]:grid-cols-3">
          <section v-for="column in block.content.columns" :key="column.id">
            <SiteEditableText v-model="column.title" as="h2" class="site:text-sm site:font-bold" />
            <nav :aria-label="column.title" class="site:mt-4 site:grid site:gap-3">
              <SiteLink v-for="(link, index) in column.links" :key="`${link.label}-${index}`" :link="link" class="site:text-sm site:opacity-65">{{ link.label }}</SiteLink>
            </nav>
          </section>
        </div>
      </div>

      <div class="site:mt-12 site:border-t site:border-white/15 site:pt-6">
        <SiteEditableText v-model="block.content.copyright" as="p" class="site:text-sm site:opacity-55" />
      </div>
    </div>
  </footer>
</template>
